import { useState, useEffect, useCallback } from 'react';
import { getAppVisualZoomScale } from 'src/utils/fullCalendarZoom';

export default function useTableMaxHeight(scrollRef, deps = [], enabled = true) {
  const [tableMaxHeight, setTableMaxHeight] = useState('calc(100vh - 280px)');

  const updateTableMaxHeight = useCallback(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const tableElement = scrollRef?.current;
        if (!tableElement) return;

        const zoomScale = getAppVisualZoomScale() || 1;
        const tableTop = tableElement.getBoundingClientRect().top;
        const visualAvailableHeight = window.innerHeight - tableTop - 80;
        const layoutMaxHeight = visualAvailableHeight / zoomScale;

        setTableMaxHeight(`${Math.max(200, Math.floor(layoutMaxHeight))}px`);
      });
    });
  }, [scrollRef]);

  useEffect(() => {
    if (!enabled) return undefined;

    updateTableMaxHeight();

    const handleTableHeightUpdate = () => updateTableMaxHeight();
    window.addEventListener('resize', handleTableHeightUpdate);
    window.addEventListener('app_zoom_update', handleTableHeightUpdate);

    return () => {
      window.removeEventListener('resize', handleTableHeightUpdate);
      window.removeEventListener('app_zoom_update', handleTableHeightUpdate);
    };
  }, [enabled, updateTableMaxHeight, ...deps]);

  return tableMaxHeight;
}
